import { BailTaxModel } from './bail-tax.model';

export class BailLineModel {
    product: string;
    quantity: number;
    discount: number;
    unityAmount: number;
    taxes: Array<BailTaxModel>;

    constructor() {
        this.taxes = new Array<BailTaxModel>();
        this.discount = 0;
        this.quantity = 0;
        this.unityAmount = 0;
    }
}
